// extracted by mini-css-extract-plugin
export const upload = "Z_bl";
export const profileImage = "Z_y";
export const btnUpload = "Z_B";
export const inputFile = "Z_v";